import * as actions from './actions';

export type State = {
  loading: boolean;
  error: Record<string, string>;
  plans: Array<Record<string, any>>;
  participantProfile: Array<Record<string, any>>;
};

export default (
  state: any = {
    error: {},
    plans: [],
    participantProfile: {},
  },
  action: any,
): State => {
  switch (action.type) {
    case actions.FETCH_PLANS:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_PLANS_SUCCESS:
      return {
        ...state,
        plans: action.payload,
        loading: false,
      };
    case actions.FETCH_PLANS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case actions.FETCH_PARTICIPANT_PROFILE:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_PARTICIPANT_PROFILE_SUCCESS:
      return {
        ...state,
        participantProfile: action.payload,
        loading: false,
      };
    case actions.FETCH_PARTICIPANT_PROFILE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case actions.FETCH_RIX_COMPENSATION:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_RIX_COMPENSATION_SUCCESS:
      return {
        ...state,
        rixCompensation: action.payload,
        loading: false,
      };
    case actions.FETCH_RIX_COMPENSATION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};
